import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export function initProductsSlider() {
  const mbProductSlider = document.querySelectorAll(".products-slider");
  let mbProductSwiper = [];

  for (let i = 0; i < mbProductSlider.length; i++) {
    const paginationEl = mbProductSlider[i]
      .closest(".products-slider")
      .querySelector(".swiper-pagination");
    const navigationWrapper = mbProductSlider[i]
      .closest(".products-slider")
      .querySelector(".swiper-navigation");
    const nextEl = navigationWrapper.querySelector(".swiper-button-next");
    const prevEl = navigationWrapper.querySelector(".swiper-button-prev");

    mbProductSwiper[i] = new Swiper(mbProductSlider[i], {
      modules: [Pagination, Navigation],
      loop: false,
      slidesPerView: 1,
      spaceBetween: 25,
      pagination: {
        el: paginationEl,
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        920: {
          slidesPerView: 3,
        },
        1240: {
          slidesPerView: 4,
        },
      },
    });
  }
}
